import classNames from "classnames";
export const Container = ({ children, isFullWidth, isCheckout, className }) => {
    const defaultClassNames = isFullWidth
        ? "max-w-screen"
        : "w-full max-w-full relative lg:max-w-[960px] xl:max-w-[1140px] 2xl:max-w-[1400px] mx-auto";
    return (<div className={classNames(defaultClassNames, className, isCheckout ? "mb-17.5" : "")}>
            {isFullWidth ? <div className="relative">{children}</div> : <>{children}</>}
        </div>);
};
